import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  inviteId: string | number;
};

export const deleteInvite = async (
  scope: RequestScope,
  { inviteId }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<unknown>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<unknown>>(`/organization/invite/${inviteId}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
